<template>
    <div>
        <div class="google-map" id="google-map" ref="googleMap"></div>
        <template v-if="Boolean(this.google) && Boolean(this.map)">
            <slot
                    :google="google"
                    :map="map"
            />
        </template>
    </div>
</template>

<script>
    import {Loader, LoaderOptions} from 'google-maps';

    export default {
        props: {
            // mapConfig: Object,
            // apiKey: String,
            locations: Array,
            center: Object,
        },

        data() {
            return {
                google: null,
                map: null,
                loader: null,
                options: {},


                mapConfig: {
                    center: this.center && this.center.lat ? { lat: this.center.lat, lng: this.center.lon } : { lat: -34.397, lng: 150.644 },
                    zoom: 8,
                    // mapTypeControlOptions: {
                    //     mapTypeIds: ['map_style', this.google.maps.MapTypeId.SATELLITE]
                    // },
                    streetViewControl: false,
                    fullscreenControl: false,
                    gestureHandling: 'greedy'
                },
                markers: [],
                infowindow: null,
                boundes: null,
                stopEventRecursion: null,
                apiKey: 'AIzaSyB1s8BSk8ML5V1XTkcn1s7pgxApFHBN4Hw'
            }
        },

        async mounted() {
            this.initializeMap();
        },

        methods: {
            async initializeMap() {
                // TODO check if needed?
                const mapContainer = this.$refs.googleMap;
                this.loader = new Loader(this.apiKey, this.options);
                this.google = await this.loader.load();
                // END

                let center = new this.google.maps.LatLng(this.center.lat, this.center.lon);
                this.bounds = new this.google.maps.LatLngBounds();
                this.infowindow = new this.google.maps.InfoWindow({content: ''});
                this.stopEventRecursion = false; // ?
                this.markers = []; // ?

                let styles = [
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {"visibility": "off"}
                        ]
                    }, {
                        "featureType": "road.highway",
                        "stylers": [
                            {"visibility": "on"}
                        ]
                    }
                ];

                let mapOptions = {
                    center: center,
                    zoom: 12,
                    mapTypeControlOptions: {
                        mapTypeIds: ['map_style', this.google.maps.MapTypeId.SATELLITE]
                    },
                    streetViewControl: false,
                    fullscreenControl: false,
                    gestureHandling: 'greedy'
                };

                this.map = new this.google.maps.Map(mapContainer, mapOptions);

                let styledMap = new this.google.maps.StyledMapType(styles, {name: "Map"});
                this.map.mapTypes.set('map_style', styledMap);
                this.map.setMapTypeId('map_style');

                this.bounds.extend(center);

                this.google.maps.event.trigger(this.map, 'resize');
                this.map.setZoom(this.map.getZoom());

                setTimeout(() => {
                    let center = this.map.getCenter();

                    document.getElementById("google-map").style.width = 'auto';
                    document.getElementById("google-map").style.height = '250px';
                    this.google.maps.event.trigger(this.map, 'resize');
                    this.map.setCenter(center);
                    this.AddPins();
                }, 0 );

            },
            AddPins() {
                let locations = this.locations;
                let dups = [];

                let center = new this.google.maps.LatLng(this.center.lat, this.center.lon);
                // center pin
                let mapMarker = new this.google.maps.Marker({
                    position: center,
                    title: '',
                    map: this.map,
                    icon: {
                        url: ('http://maps.google.com/mapfiles/ms/icons/blue.png'),
                        labelOrigin: new this.google.maps.Point(15, 10),
                    },
                    zIndex: 1000
                });
                this.markers[0] = mapMarker;
                this.bounds.extend(center);

                for(let i = 0; i < locations.length; ++i) {
                    let map_number = (i + 1).toString();
                    let info = "<span style='background-color: white;'>Map#: " + map_number + "<br />" + locations[i]['CONAME'] + "</span>";
                    let pinPosition = new this.google.maps.LatLng(locations[i]['lat'], locations[i]['lng']);
                    let indexToCheck = locations[i]['lat']+'_'+locations[i]['lng'];
                    if(dups[indexToCheck] === undefined) {
                        // new pin
                        let mapMarker = new this.google.maps.Marker({
                            position: pinPosition,
                            title: locations[i]['CONAME'],
                            map: this.map,
                            icon: {
                                url: ('http://maps.google.com/mapfiles/ms/icons/red.png'),
                                labelOrigin: new this.google.maps.Point(15, 10),
                            },
                            label: {
                                text: map_number,
                                fontSize: '9px',
                                color: 'black',
                                fontWeight: 'bold'
                            },
                            info: info,
                            zIndex: 1000 + i + 1
                        });
                        this.markers[i] = mapMarker;
                        this.bounds.extend(pinPosition);
                        mapMarker.addListener('click', () => {
                            this.OnMarkerClick(mapMarker);
                        });
                        dups[indexToCheck] = i;
                    } else {
                        // Pin already exists at those coordinates.
                        this.markers[dups[indexToCheck]].setIcon("http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=|c8c8c8|000000");
                        this.markers[dups[indexToCheck]].setLabel("");
                        let infoToAdd = "<hr>Map#: " + map_number + "<br />"+locations[i]['CONAME'] + "</span>";
                        this.markers[dups[indexToCheck]].info = this.markers[dups[indexToCheck]].info.replace("</span>", infoToAdd);
                        this.markers[i] = this.markers[dups[indexToCheck]];
                    }
                }
            },
            OnMarkerClick(marker) {
                let index = marker.zIndex - 1000; // TODO: If multi-location markers are used, replace this! Two+ markers will share the same index!
                this.BounceMarker(marker, 750);
                this.infowindow.setContent(marker.info);
                this.infowindow.open(marker.getMap(), marker);
                if(marker.fromSidebar !== undefined) {
                    this.SidebarClick(marker.fromSidebar, false);
                } else {
                    this.SidebarClick(index, false);
                }
            },
            BounceMarker(markerElement, duration) {
                markerElement.setAnimation(google.maps.Animation.BOUNCE);
                markerElement.getMap().setCenter(markerElement.getPosition());
                window.setTimeout(function () {
                    markerElement.setAnimation(null);
                }, duration);
            },
            SidebarClick(id, fromSidebar) { // Actual logic call.
                // id = id - 1;
                if(fromSidebar !== true) {
                    this.stopEventRecursion = true;
                    document.getElementById('mapHref_' + id).click();
                    // Scroll to opened div.
                    // this.ScrollToSidebarItem(id);
                }
            },
            ScrollToSidebarItem(id) {
                let panel = $(".panel_" + id);
                let container = $('.map_left_col');

                let topOffset = $(".panel_0").position().top;
                let containerHeight = container.height();
                let containerScrollValue = container.scrollTop();
                let panelBodyHeight = panel.find('.panel-body').height();

                let scrollTo = panel.position().top - topOffset;
                let scrollAdjustment = -(containerHeight / 2);
                scrollAdjustment += panelBodyHeight;

                container.scrollTo(scrollTo + scrollAdjustment);
            },
            ReCenterMap() {
                this.map.fitBounds(this.bounds, 0);
            }
        },
        OnSidebarClick(id, fromSidebar) { // Event call.
            this.markers[id-1].set('fromSidebar', id);
            this.google.maps.event.trigger(this.markers[id-1], 'click');
            //SidebarClick(id, fromSidebar);
        }

    }
</script>

<style lang="scss">
    .sidebar_marker {
        /*box-shadow:inset 0 0 1px #f00;*/
        border-bottom: 1px solid #ccc;
        font-size: 12px;
        line-height: 1.2;
        /*max-width:100px;*/
    }

.sidebar_toggle {
  /*box-shadow:inset 0 0 1px #00f;*/
  width: 100%;
  text-align: left;
  padding: 0.5em;
  background: #f1f1f1;
  font-weight: 500;
  /*padding-right:.5em;*/
}
</style>
